export const DEFAULT_ASSET_CARD_CONFIG = {
  deviceDetailsMaxItems: 4,
  deviceDetailsFields: ["asset_name", "category_subcategory", "type"],
  categories: [
    {
      value: "AC",
      label: "AC",
      assetTypes: [
        "AC - Package",
        "AC - Duct Split",
        "AC - VAV",
        "AC - Chiller",
        "AC - AHU",
        "AC- FAHU",
        "AC - Split Unit",
        "AC - Cassette",
        "AC - CRAC",
        "AC - Stand Unit",
        "FCU",
      ],
    },
    {
      value: "Pump",
      label: "Pump",
      assetTypes: ["Submersible Pump", "Booster Pump", "Fire Pump System", "Transfer Pump"],
    },
    { value: "Solar System", label: "Solar System", assetTypes: [] },
    { value: "Generator", label: "Generator", assetTypes: [] },
    { value: "Water Tank", label: "Water Tank", assetTypes: [] },
  ],
};

export const ASSET_CARD_DEVICE_DETAILS_FIELDS = [
  { value: "asset_name", label: "Asset Name", path: ["asset_name"] },
  { value: "asset_code", label: "Asset Code", path: ["asset_code"] },
  { value: "category_subcategory", label: "Category", path: ["category_subcategory"] },
  { value: "type", label: "Asset Type", path: ["type"] },
  { value: "brand", label: "Brand", path: ["brand"] },
  { value: "model_number", label: "Model", path: ["model_number"] },
  { value: "serial_number", label: "Serial", path: ["serial_number"] },
  { value: "location", label: "Location", path: ["location"] },
  { value: "ac_capacity", label: "AC Capacity", path: ["ac_capacity"] },
  { value: "capacity_rating", label: "Capacity Rating", path: ["OperationalData", "capacity_rating"] },
  { value: "power", label: "Power", path: ["OperationalData", "power"] },
  { value: "voltage", label: "Voltage", path: ["OperationalData", "voltage"] },
  { value: "current", label: "Current", path: ["OperationalData", "current"] },
  { value: "capacity_cfm", label: "CFM", path: ["OperationalData", "capacity_cfm"] },
  { value: "condition_status", label: "Condition", path: ["MaintenanceLifecycle", "condition_status"] },
  { value: "criticality_level", label: "Criticality", path: ["MaintenanceLifecycle", "criticality_level"] },
  { value: "department_owner", label: "Department Owner", path: ["FinancialOwnership", "department_owner"] },
  { value: "supplier_vendor", label: "Supplier", path: ["FinancialOwnership", "supplier_vendor"] },
  { value: "monitored_parameters", label: "Monitored Parameters", path: ["IotMonitoring", "monitored_parameters"] },
];

const number = "number";
const text = "text";

export const COMPRESSOR_FIELDS = [
  { name: "voltage", label: "Voltage", type: number },
  { name: "running_current", label: "Running Current", type: number },
  { name: "starting_current", label: "Starting Current", type: number },
  { name: "power", label: "Power", type: number },
  { name: "hp", label: "HP", type: number },
  { name: "rla", label: "RLA", type: number },
  { name: "lra", label: "LRA", type: number },
  { name: "fla", label: "FLA", type: number },
];

export const FAN_FIELDS = [
  { name: "voltage", label: "Voltage", type: number },
  { name: "running_current", label: "Running Current", type: number },
  { name: "starting_current", label: "Starting Current", type: number },
  { name: "power", label: "Power", type: number },
  { name: "rpm", label: "RPM", type: number },
  { name: "hp", label: "HP", type: number },
];

export const OPERATIONAL_FIELD_DEFINITIONS = {
  AC: [
    { name: "power_supply", label: "Power Supply", type: number },
    { name: "kw_thermal", label: "Kw Thermal", type: number },
    { name: "kw_electrical", label: "Kw Electrical", type: number },
    { name: "capacity_ton", label: "Capacity (ton)", type: number },
    { name: "efficiency", label: "Efficiency", type: number },
    { name: "number_of_compressors", label: "Number of compressors", type: number, integer: true, group: "compressors" },
    { name: "number_of_indoor_fans", label: "Number of indoor fans", type: number, integer: true, group: "indoor_fans" },
    { name: "number_of_outdoor_fans", label: "Number of outdoor fans", type: number, integer: true, group: "outdoor_fans" },
    { name: "coverage_area", label: "Coverage Area", type: number },
    { name: "capacity_cfm", label: "Capacity (CFM)", type: number },
    { name: "light_intensity", label: "Light Intensity", type: number },
    { name: "refrigerant_type", label: "Refrigerant Type / Charge", type: text },
  ],
  "AC - VAV": [
    { name: "actuator_type", label: "Actuator Type", type: text },
    { name: "related_current", label: "Related Current", type: number },
    { name: "voltage", label: "Voltage", type: number },
    { name: "coverage_area", label: "Coverage Area", type: number },
    { name: "room_size", label: "Room Size", type: number },
    { name: "capacity_cfm", label: "CFM", type: number },
    { name: "light_intensity", label: "Light Intensity", type: text },
    { name: "vav_width", label: "VAV's Width", type: number },
    { name: "vav_length", label: "VAV's Length", type: number },
  ],
  Pump: [
    { name: "motor_capacity", label: "Motor Capacity (KWH/HP)", type: number },
    { name: "voltage", label: "Voltage", type: number },
    { name: "rated_current", label: "Rated Current", type: number },
    { name: "flow_m3h", label: "Flow (M3/h)", type: number },
    { name: "rated_flow_rate_m3h", label: "Rated Flow Rate (m^3/h)", type: number },
    { name: "rated_rpm", label: "Rated RPM", type: number },
    { name: "connection_type", label: "Connection type", type: text },
    { name: "max_operating_pressure", label: "Max. Operating Pressure", type: number },
    { name: "control_type", label: "Control Type", type: text },
    { name: "head_m3", label: "Head (M^3)", type: number },
    { name: "max_water_temp", label: "Max Water Temp", type: number },
  ],
  Generator: [
    { name: "rated_capacity", label: "Rated Capacity", type: number },
    { name: "rated_voltage", label: "Rated Voltage", type: number },
    { name: "max_rated_current", label: "Max/Rated Current", type: number },
    { name: "rated_power_factor", label: "Rated Power Factor", type: number },
    { name: "rated_frequency", label: "Rated Frequency", type: number },
    { name: "fuel_tank_capacity", label: "Fuel Tank Capacity", type: number },
    { name: "fuel_type", label: "Fuel Type", type: text },
  ],
  "Solar System": [
    { name: "total_pv_capacity_dc", label: "Total PV Capacity (DC)", type: number },
    { name: "inverter_ac_rating", label: "Inverter AC Rating", type: number },
    { name: "tilt_azimuth_angles", label: "Tilt & Azimuth Angles", type: number },
    { name: "panel_size", label: "Panel Size", type: number },
    { name: "connection_type", label: "Connection Type", type: text },
    { name: "battery_capacity", label: "Battery Capacity", type: number },
  ],
  "Water Tank": [
    { name: "tank_type", label: "Type", type: text },
    { name: "shape", label: "Shape", type: text },
    { name: "length", label: "Length", type: number },
    { name: "width", label: "Width", type: number },
    { name: "height", label: "Height", type: number },
    { name: "location", label: "Location", type: text },
  ],
};

export const getOperationalFieldsForAsset = (category, assetType) => {
  if (category === "AC" && assetType === "AC - VAV") {
    return OPERATIONAL_FIELD_DEFINITIONS["AC - VAV"];
  }
  return OPERATIONAL_FIELD_DEFINITIONS[category] || [];
};

export const normalizeStringList = (value) =>
  (Array.isArray(value) ? value : [])
    .map((item) => (typeof item === "string" ? item : item?.value || item?.label || ""))
    .map((item) => String(item).trim())
    .filter(Boolean);

export const normalizeAssetCardConfig = (value = {}) => {
  const rawMaxItems = Number(value.deviceDetailsMaxItems);
  const deviceDetailsMaxItems = Number.isFinite(rawMaxItems)
    ? Math.min(8, Math.max(1, Math.trunc(rawMaxItems)))
    : DEFAULT_ASSET_CARD_CONFIG.deviceDetailsMaxItems;
  const rawCategories = Array.isArray(value.categories) ? value.categories : DEFAULT_ASSET_CARD_CONFIG.categories;
  const validFieldSet = new Set(ASSET_CARD_DEVICE_DETAILS_FIELDS.map((field) => field.value));
  const deviceDetailsFields = normalizeStringList(value.deviceDetailsFields)
    .filter((field) => validFieldSet.has(field));
  const categories = rawCategories
    .map((category) => {
      const label = String(category?.label || category?.value || "").trim();
      const categoryValue = String(category?.value || label).trim();
      if (!categoryValue) return null;
      return {
        value: categoryValue,
        label: label || categoryValue,
        assetTypes: normalizeStringList(category?.assetTypes),
      };
    })
    .filter(Boolean);

  return {
    deviceDetailsMaxItems,
    deviceDetailsFields: deviceDetailsFields.length ? deviceDetailsFields : DEFAULT_ASSET_CARD_CONFIG.deviceDetailsFields,
    categories: categories.length ? categories : DEFAULT_ASSET_CARD_CONFIG.categories,
  };
};

export const getAssetTypesForCategory = (config, categoryValue) =>
  (normalizeAssetCardConfig(config).categories.find((category) => category.value === categoryValue)?.assetTypes || [])
    .map((value) => ({ value, label: value }));

export const parseOptionalNumber = (value) => {
  if (value === "" || value === null || value === undefined) return null;
  const numberValue = Number(value);
  return Number.isFinite(numberValue) ? numberValue : value;
};

export const parseOptionalInteger = (value) => {
  if (value === "" || value === null || value === undefined) return null;
  const numberValue = Number(value);
  return Number.isFinite(numberValue) ? Math.max(0, Math.trunc(numberValue)) : value;
};
